import React from 'react';
import PropTypes from 'prop-types';
import {Tabs, Tab, TabList, TabPanel} from 'react-tabs';
import './index.css'

function SMCTabsContainer({
    children,
    minHeight,
    height,
    width,
    style,
    tabOnClick
}) {
    const tabs = [];
    const tabPages = [];

    React.Children.forEach(children, (child) => {
        if (child && child.props && child.props.title && child.props.children) {
            tabs.push(<Tab onClick={() => tabOnClick && tabOnClick(child.props.id)} key={child.props.title}>{child.props.title}</Tab>);
            tabPages.push(<TabPanel style={{ height, minHeight, ...style }} key={child.props.title}>{child.props.children}</TabPanel>);
        }
    });

    return (
        <Tabs style={{ width }}>
            <TabList style={{ width }}>
                {tabs}
            </TabList>
            {tabPages}
        </Tabs>
    );
}

SMCTabsContainer.propTypes = {
    children: PropTypes.node.isRequired,
    minHeight: PropTypes.number,
    height: PropTypes.number,
    width: PropTypes.number,
    style: PropTypes.object,
    tabOnClick: PropTypes.func
}

export default SMCTabsContainer;